export default __webpack_public_path__ + "static/media/tw.e6fa23f7.svg";